import { cloneElement, Suspense } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import Loader from "../../components/loader/Loader";
import NavBar from "../../components/navbar/NavBar";
import { AnimatePresence } from "framer-motion";
import Footer from "../../components/footer/Footer";

export default function Layout(){

    // const [lenisKey, setLenisKey] = useState(null);

    const AnimatedOutlet = () => {
        const location = useLocation();
        const element = useOutlet();

        return (
            <AnimatePresence 
                mode="wait" 
                initial={true} 
                // onExitComplete={ () => {setLenisKey(location.pathname)}}
            >
                    {element && cloneElement(element, {key: location.key})}
            </AnimatePresence>
        );
    }

    return(
        <>

            {/* <SmoothScroll newKey={lenisKey}> */}


                <div 
                    className="
                        scroll-smooth 
                        bg-body-bg-light 
                        dark:bg-body-bg-dark
                    "
                    // className="
                    //     no-scrollbar 
                    //     scroll-smooth 
                    //     bg-body-bg-light 
                    //     dark:bg-body-bg-dark
                    //     overflow-y-scroll
                    // "
                >
                    <div className="h-screen w-screen relative">
                        <main>
                            <NavBar />
                            <Suspense fallback={<Loader />}>
                                <AnimatedOutlet />
                                {/* <Outlet /> */}
                            </Suspense>
                            <Footer />
                        </main>
                    </div>
                </div>


            {/* </SmoothScroll> */}

        </>
    )
}